<script setup lang="ts">
import type { ComputedRef } from "vue";
import { SelectViewport, type SelectViewportProps, useForwardProps } from "reka-ui";

const props = withDefaults(defineProps<SelectViewportProps>(), {});
// Only the set props; typed as such (see HPixSelectArrow).
const forwarded = useForwardProps(props) as ComputedRef<SelectViewportProps>;
</script>

<template>
  <SelectViewport v-bind="forwarded">
    <slot />
  </SelectViewport>
</template>
